import script from "./syncDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./syncDialog.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__